/**
 * The Pipeline's outlook of each repo (shared/pipeline.ts) the server pushed
 * (`{t:"pipeline"}`, server/pipelinePush.ts), by repo, replaced whole on each
 * push. Module-level, like lib/gitGraphs.ts. A push missed is not replayed: the
 * view reads `GET /api/tmux/pipeline` when it opens and on reconnect (`sessionsGen`).
 */
import { shallowRef } from "vue";
import type { PipelineSnapshot } from "@shared/pipeline.js";

export const pipelineSnaps = shallowRef<ReadonlyMap<string, PipelineSnapshot>>(new Map());

export function pipelinePushed(repo: string, snap: PipelineSnapshot): void {
  const next = new Map(pipelineSnaps.value);
  next.set(repo, snap);
  pipelineSnaps.value = next;
}

/** A whole read: every repo's, the ones it lacks dropped. */
export function pipelineRead(snaps: readonly PipelineSnapshot[]): void {
  pipelineSnaps.value = new Map(snaps.map((s) => [s.repo, s]));
}
